import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "ceremony-wheel-container"
};
const _hoisted_2 = {
  class: "ceremony-info"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  class: "duration"
};
const _hoisted_5 = {
  class: "desc"
};
const _hoisted_6 = {
  class: "spinner-container"
};
const _hoisted_7 = {
  key: 1,
  class: "ceremony-props-list"
};
import { computed, onMounted, ref } from 'vue';
import router from '@/router';
import { request } from '@/manager/net_manager';
import PropsSpinner from '@/components/Ceremony/PropsSpinner.vue';
import PropsCard from '@/components/Props/PropsCard.vue';
import { ElMessage } from 'element-plus';
import store from "@/store";
import { pageStyle } from "@/theme/sliderStyle";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import PocketPropsCard from "@/components/Props/PocketPropsCard.vue"; // refs

export default {
  __name: 'CeremonyPage',

  setup(__props) {
    const ceremonyId = ref('');
    const ceremony = ref(null);
    const records = ref([]);
    const selectedProp = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook || null);
    const ceremonies = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.ceremonies ?? [];
    }); // functions

    const getData = () => {
      if (!ceremonyId.value) {
        ElMessage.error({
          message: '没有检索到庆典信息',
          duration: 1500
        });
        setTimeout(() => goBack(), 1500);
        return;
      }

      let parameters = {
        'ceremony_id': ceremonyId.value
      };
      request('ceremony/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        ceremony.value = response.data;
      });
    };

    const updateRecord = propData => {
      records.value.unshift(propData);
    };

    const getRecords = () => {
      if (!ceremonyId.value) return;
      let parameters = {
        'ceremony_id': ceremonyId.value
      };
      request('ceremony/records/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        records.value = response.data;
      });
    };

    const goBack = () => {
      router.back();
    }; // lifecycle


    onMounted(() => {
      if (ceremonies.value && ceremonies.value.length > 0) {
        ceremonyId.value = ceremonies.value[0]?.id;
      }

      getData();
      getRecords();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [ceremony.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("text", null, [_createElementVNode("span", _hoisted_3, _toDisplayString(ceremony.value.name), 1), _createElementVNode("span", _hoisted_4, "（" + _toDisplayString(ceremony.value.start_time) + " ~ " + _toDisplayString(ceremony.value.end_time) + "）期间限定开放", 1)]), _createElementVNode("text", _hoisted_5, _toDisplayString(ceremony.value.desc), 1)]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_6, [ceremony.value.props.length > 0 ? (_openBlock(), _createBlock(PropsSpinner, {
        key: 0,
        ceremony: ceremony.value,
        onUpdateRecord: updateRecord
      }, null, 8, ["ceremony"])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), records.value && records.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (item, key) => {
        return _openBlock(), _createBlock(PropsCard, {
          key: key,
          data: item,
          "pocket-mode": true,
          onClick: $event => selectedProp.value = item
        }, null, 8, ["data", "onClick"]);
      }), 128))])) : _createCommentVNode("", true), selectedProp.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 2,
        onClose: _cache[0] || (_cache[0] = $event => selectedProp.value = null)
      }, {
        default: _withCtx(() => [_createVNode(PocketPropsCard, {
          "prop-id": selectedProp.value?.id,
          operationEnable: false
        }, null, 8, ["prop-id"])]),
        _: 1
      })) : _createCommentVNode("", true)], 4);
    };
  }

};